<template>
  <div>
    <main-header/>
    <nav-bar class="d-md-block d-none"/>
    <div v-if="isPageLoaded" class="container ">
      <div class="row mb-8 ">
        <div class="col-12 col-md mx-auto">
          <h1 class="pt-5 px-5 text-center border-bottom-title mb-6 "> {{
              BlogPostDetail.Title
            }}
          </h1>
          <v-img :alt=BlogPostDetail.Title :src="$replaceHttps(BlogPostDetail.FileUrl)"
                 class="mx-auto border border-10px-Articles-image" contain height="300px"></v-img>
          <div class="border border-10px-Articles-body p-4">
            <div class=" border-10px-Articles-body">
              <div class="pt-5 px-5 overflow-hidden black-text font-12"
                   v-html="BlogPostDetail.Description"></div>
              <v-divider></v-divider>
              <div class="row">
                <div class="col text-center black-text font-12">
                  <i class="fas fa-eye px-2 black-text"></i>
                  {{ BlogPostDetail.Views }}
                </div>
                <div class="col text-center black-text font-12">
                  {{ $moment(BlogPostDetail.CreateDate) }}
                  <i class="fas fa-calendar-alt px-2 black-text"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    <navigation-drawer :drawer="drawer"/>

  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import MainHeader from "@/components/mainHeader.vue";
import NavBar from "@/components/navBar.vue";
import NavigationDrawer from "@/components/navigationDrawer.vue";

export default {
  name: "BlogPostsDetails",
  components: {NavigationDrawer, NavBar, MainHeader, Footer},
  data: () => ({
    drawer: false,
    isPageLoaded: false,
    BlogPostDetail: {},
    showLoaderDialog: false,
    keywords: "",
    description: "",
    imageUrl: ""
  }),
  metaInfo() {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.keywords
        },
        { //  set meta
          name: 'description',
          content: this.description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.imageUrl,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.imageUrl,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  mounted() {
    this.getData()

  },
  methods: {
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Home/BlogDetail?blogId=" + this.$route.params.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.BlogPostDetail = json;
            this.keywords = json.MetaTagKeywords;
            this.description = json.MetaTagDescription;
            this.imageUrl = json.FileUrl;
            this.showLoaderDialog = false;
            this.isPageLoaded = true
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>
